import styled from 'styled-components';

export const CardContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '32px'
});

export const GuidanceBlock = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
});

export const FieldsBlock = styled('div')({
    marginTop: '24px'
});

export const ApplyMethodSection = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: '16px'
});

export const ApplyMethodOptionWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',

    '& .MuiFormControlLabel-label': {
        whiteSpace: 'nowrap'
    }
});

export const ApplyMethodDescription = styled('div')({
    paddingLeft: '28px'
});
